export const ALL_CITY_POST = "city/list";
export const CITY_DETAILS_GET = "city/detail";
export const DELETE_CITY_POST = "city/delete";
export const ADD_CITY_POST = "city/add";
export const UPDATE_CITY_POST = "city/update";
export const COUNTRY_LIST_FOR_CITY_GET = "city/create";
export const ZONE_LIST_FOR_CITY_GET = "city/zone";
export const STATE_LIST_FOR_CITY_GET = "city/state";